import { Button } from "@/components/ui/button";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

const SKELETON_ROWS = ["alpha", "bravo", "charlie"];

type MaterialRequestRow = {
	materialId?: string | null;
	material?: string | null;
	name?: string | null;
	quantity?: number | null;
};

type MaterialRequestTableProps = {
	data: MaterialRequestRow[];
	loading?: boolean;
	onRemove: (entry: MaterialRequestRow) => void;
};

const getRowKey = (entry: MaterialRequestRow) => {
	const key = entry.materialId ?? entry.material ?? entry.name ?? "material";
	const quantity = entry.quantity ?? 0;
	return `${key}-${quantity}`;
};

export function MaterialRequestTable({
	data,
	loading = false,
	onRemove,
}: MaterialRequestTableProps) {
	const renderSkeleton = () => (
		<TableBody>
			{SKELETON_ROWS.map((rowKey) => (
				<TableRow
					key={`material-request-skeleton-${rowKey}`}
					className="animate-pulse"
				>
					<TableCell>
						<div className="h-4 w-16 rounded bg-muted/70" />
					</TableCell>
					<TableCell>
						<div className="h-4 w-48 rounded bg-muted/60" />
					</TableCell>
					<TableCell className="text-right">
						<div className="ml-auto h-8 w-20 rounded bg-muted/50" />
					</TableCell>
				</TableRow>
			))}
		</TableBody>
	);

	const renderRows = () => (
		<TableBody>
			{data.map((entry) => (
				<TableRow key={getRowKey(entry)}>
					<TableCell>{entry.quantity ?? 0}</TableCell>
					<TableCell>{entry.name ?? "-"}</TableCell>
					<TableCell className="text-right">
						<Button
							variant="secondary"
							size="sm"
							onClick={() => onRemove(entry)}
							disabled={loading}
						>
							Remover
						</Button>
					</TableCell>
				</TableRow>
			))}
		</TableBody>
	);

	return (
		<div className="overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead className="w-[160px]">Quantidade</TableHead>
						<TableHead>Material</TableHead>
						<TableHead className="w-[140px] text-right">Ações</TableHead>
					</TableRow>
				</TableHeader>
				{loading ? renderSkeleton() : renderRows()}
			</Table>
		</div>
	);
}
